import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import WelcomePage from './pages/Welcome';
import ProviderSearchWithNavigate from './pages/ProviderSearch';
import './App.css';

const theme = createTheme();

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router basename="/mpn">
                <Routes>
                    <Route path="/" element={<WelcomePage />} />
                    <Route path="/provider-search" element={<ProviderSearchWithNavigate />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
}

export default App;